import React, { useEffect } from 'react';
import styles from '../../styles/educationFair.module.scss'
import EduFairWhyAttend from '../../components/OverseasEdutionFair/eduFairWhyAttent';
import EduFairStudentScholarship from '../../components/OverseasEdutionFair/eduFairStudScholarshi';
import WhyChoosKcStudyAbroad from '../../components/OverseasEdutionFair/eduFairWhyChoosekc';
import EduFairKcByNumber from '../../components/OverseasEdutionFair/eduFairKcByNumber';
import EduFairStudentTestimonials from '../../components/OverseasEdutionFair/eduFairStudTestimonials';
import EduFairParticipatingUniversity from '../../components/OverseasEdutionFair/eduFairParticipatingUniv';
import EduFairFooterCommon from '../../components/OverseasEdutionFair/eduFairFooter';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import BannerSection from '../../components/OverseasEdutionFair/BannerSection';
import GrabChanceSection from '../../components/OverseasEdutionFair/GrabChanceSection';
import WhoWillMeetSection from '../../components/OverseasEdutionFair/WhoWillMeetSection';
import SpecialOffersSection from '../../components/OverseasEdutionFair/SpecialOffersSection';
import StepUpSection from '../../components/OverseasEdutionFair/StepUpSection';
import AccomplishSection from '../../components/OverseasEdutionFair/AccomplishSection';
import LazyReveal from '../LazyReveal';

const LandingPage: React.FC = (props: any) => {
  const eventData = props.pageData[0]

  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--event-bgcolor', eventData?.backgroundColor || "#6C48F0");
  }, [])

  const renderSwitchData = () => {
    switch (eventData.selectTemplate) {
      case 'template1':
        return (
          <>
            <BannerSection eventData={eventData} />
            {eventData?.whyAttendSection && <LazyReveal className={styles.ngpWhyAttend}>
              <EduFairWhyAttend data={eventData?.whyAttendSection} />
            </LazyReveal>}
            {eventData?.participatingSection?.length > 0 && <LazyReveal>
              <EduFairParticipatingUniversity data={eventData?.participatingSection} sectionTitle={eventData?.participatingSectionTitle} sectionBgColor={eventData?.participatingSectionBgColor} />
            </LazyReveal>}
            <GrabChanceSection eventData={eventData} />
            {eventData?.whoYouMeetSection && <WhoWillMeetSection eventData={eventData} />}
            {eventData?.specialOffersSection && <SpecialOffersSection eventData={eventData} />}
            {eventData?.stepUpSection && <StepUpSection eventData={eventData} />}
            {eventData?.topScholarships?.length > 0 && <LazyReveal className={styles.ngpStuSchol}>
              <EduFairStudentScholarship title={eventData?.scholarshipTitle} scholarshipData={eventData?.topScholarships} sectionBgColor={eventData?.scholarshipSectionBgColor} />
            </LazyReveal>}
            {eventData?.whyChooseKc && <LazyReveal>
              <WhyChoosKcStudyAbroad data={eventData?.whyChooseKc} />
            </LazyReveal>}
            <AccomplishSection eventData={eventData} />
            {eventData?.studentsSaySection && <LazyReveal>
              <EduFairStudentTestimonials data={eventData?.studentsSaySection} />
              </LazyReveal>}
            {eventData?.kcNumbersSection && <LazyReveal>
              <EduFairKcByNumber data={eventData?.kcNumbersSection} />
            </LazyReveal>}
            {eventData?.footer && <LazyReveal>
              <EduFairFooterCommon data={eventData?.footer} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink}/>
            </LazyReveal>}
          </>
        )
      case 'template2':
        return (
          <>
            <BannerSection eventData={eventData} />
            {eventData?.stepUpSection && <StepUpSection eventData={eventData} />}
            {eventData?.whoYouMeetSection && <WhoWillMeetSection eventData={eventData} />}
            <GrabChanceSection eventData={eventData} />
            {eventData?.specialOffersSection && <SpecialOffersSection eventData={eventData} />}
            {eventData?.whyChooseKc && <LazyReveal>
              <WhyChoosKcStudyAbroad data={eventData?.whyChooseKc} />
            </LazyReveal>}
            <AccomplishSection eventData={eventData} />
            {eventData?.whyAttendSection && <LazyReveal className={styles.ngpWhyAttend}>
              <EduFairWhyAttend data={eventData?.whyAttendSection} />
            </LazyReveal>}
            {eventData?.studentsSaySection && <LazyReveal>
              <EduFairStudentTestimonials data={eventData?.studentsSaySection} />
            </LazyReveal>}
            {eventData?.kcNumbersSection && <LazyReveal>
              <EduFairKcByNumber data={eventData?.kcNumbersSection} />
            </LazyReveal>}
            {eventData?.footer && <LazyReveal>
              <EduFairFooterCommon data={eventData?.footer} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink} />
            </LazyReveal>}
          </>
        )
    }
  }

  return (
    <>
      {props.pageData?.length > 0 && <MetaTagsComp {...props.pageData[0].meta} />}
      {renderSwitchData()}
    </>
  )

}

export default LandingPage;